//@flow
import * as actionTypes from './actionTypes';
import reduce from '../reduce';
import type { ReducerState$Type,Action$Type } from '../genericFlowTypes'

const initialState:ReducerState$Type = {
    error: '',
    invoiceSubmitted: false,
    resultset: null,
    anyChanges: false,
    formData: {},
    reviewQuestions: [],
    formError: {},
    vendors: [],
    vendorsLoaded: false,
    cacheValues: null,
    requestors: [],
    requestorsLoaded: false
}

//In use : actionTypes.RHEA_INV_SUBMIT_SUCCESS
const invoiceSubmittedSuccess = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: true,
        error: ''
    }
}

//actionTypes.INV_SUBMITTED_COMPLETED
const invSubmittedCompleted = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: false
    }
}

const editVerifyFormDataSuccess=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: '',
        formData: action.formData,
        reviewQuestions: action.reviewQuestions
    }
}

const updateFormError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        formError: action.formError
    }
}

const refreshedVendors=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        vendors: action.vendors,
        vendorsLoaded: true
    }
}

const headerActionsError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: action.error
    }
}

const refreshCacheValue=(state:ReducerState$Type,action:Action$Type)=> {
    let cacheValues = state.cacheValues
    if (!cacheValues) {
        cacheValues = new Map()
    }

    cacheValues.set(action.anyKey,action.anyValue)

    return {
        ...state,
        cacheValues: cacheValues
    }
}

const refreshedRequestors=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        requestors: action.requestors,
        requestorsLoaded: true
    }
}

export default reduce(initialState,{
    [actionTypes.RHEA_INV_SUBMITTED_COMPLETED]: invSubmittedCompleted,
    [actionTypes.RHEA_INV_SUBMIT_SUCCESS]: invoiceSubmittedSuccess,
    [actionTypes.RHEA_INV_SUBMIT_ERROR]: headerActionsError,
    [actionTypes.RHEA_EDIT_VERIFY_FORM_DATA_SUCCESS]: editVerifyFormDataSuccess,
    [actionTypes.RHEA_EDIT_VERIFY_FORM_DATA_ERROR]: headerActionsError,
    [actionTypes.RHEA_UPDATE_FORM_ERROR]: updateFormError,
    [actionTypes.REFRESH_RHEA_VENDORS_SUCCESS]: refreshedVendors,
    [actionTypes.REFRESH_RHEA_VENDORS_ERROR]: headerActionsError,
    [actionTypes.REFRESH_RHEA_CACHE_VALUE]: refreshCacheValue,
    [actionTypes.REFRESH_RHEA_REQUESTORS_SUCCESS]: refreshedRequestors,
    [actionTypes.REFRESH_RHEA_REQUESTORS_ERROR]: headerActionsError
});


// WEBPACK FOOTER //
// ./src/redux/rhea/reducer.js